'use strict';

import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import AddForm from './commercialProfile/AddClient.jsx';
import Map from './commercialProfile/clientTrackingWithOSM.jsx'; //Avec Open Street Map

import ClientList from './commercialProfile/ClientListFiltered.jsx';
import { Button, Card, CardHeader, CardContent, Box, IconButton } from '@material-ui/core';
import CardPage from '../../commonModules/layouts/CardPage.jsx';
import { AddCircleOutlineRounded, PinDropRounded, ListAltRounded, MenuRounded } from '@material-ui/icons';

class CommercialElement extends Component{

    state = {
        add: false,
        map: false,
        positions: [],
        idx: 0,

    }
    render() {
       console.log('[DEBUG], commercial.jsx, render,Commercial Element,');
        return (
            <Box>
                { !this.state.map && !this.state.add &&
                    <CardPage
                        title="Liste des contrats"
                    >
                        <Box p={2}>
                            <Button
                                type="button"
                                onClick={() => this.setState({ add: true })}
                                color="primary"
                                title="Ajouter Prospect/Client"
                                startIcon={<AddCircleOutlineRounded />}
                            >
                                Nouveau Client / Prospect
                            </Button>

                            <Button
                                onClick={() => this.setState({ map: true, add: false })}
                                color="secondary"
                                title="Carte des clients"
                                startIcon={<PinDropRounded />}
                            >
                                Carte des Clients
                            </Button>
                        </Box>
                       
                        <ClientList />
                    </CardPage>
                }


                { this.state.map &&

                    <CardPage
                        title="Carte des clients"
                        subtitle="Position des clients rentrés"                    
                    >
                        <Box p={2}>
                            <Button
                                // variant="contained"
                                onClick={() => this.setState({ add: true, map: false })}
                                color="secondary"
                                title="Ajouter Prospect/Client"
                                startIcon={<AddCircleOutlineRounded />}
                                // className="btn bgm-cyan btn-icon dropdown-toggle waves-effect waves-circle waves-float"
                                // data-toggle="dropdown"
                                // aria-expanded="false"
                            >
                                Nouveau Prospect / Client
                            </Button>
                            <Button
                                // variant="contained"
                                // className="btn bgm-cyan btn-icon waves-effect waves-circle waves-float"
                                onClick={() => this.setState({ map: false, add: false })}
                                title="Liste"
                                color="primary"
                                startIcon={<ListAltRounded />}
                            >
                                Liste
                            </Button>

                        </Box>
                        
                        <Map
                            // positions={this.state.positions[this.state.idx]}
                            // idx={this.state.idx}
                        />
                    </CardPage>
                }
                       
                { this.state.add &&
                    <CardPage 
                        title="Ajouter un nouveau client / prospect"
                    >
                        <Box p={2}>
                            <Button
                                // variant="contained"
                                color="primary"
                                className="btn bgm-cyan btn-icon waves-effect waves-circle waves-float"
                                onClick={() => this.setState({ map: false, add: false })}
                                title="Liste"
                                startIcon={<MenuRounded />}
                            >
                                Liste
                            </Button>
                            <Button
                                // variant="contained"
                                color="secondary"
                                className="btn bgm-cyan btn-icon waves-effect waves-circle waves-float"
                                onClick={() => this.setState({ map: true, add: false })}
                                title="Carte des Clients"
                                startIcon={<PinDropRounded />}
                            >
                                Carte des Clients
                            </Button>
                        </Box>
                        <AddForm />
                    </CardPage>
                }


            </Box>
        )
    }

};

export default CommercialElement;
